import { GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";

const columnBuilder = (props) => {
  const {
    regionData,
    rowModesModel,
    handleEditClick,
    handleSaveClick,
    handleDeleteClick,
    handleCancelClick,
    isAdmin = false,
  } = props;

  const columns = [
    { field: "id", headerName: "ID", width: 50, editable: false },
    {
      field: "companyName",
      headerName: "Firma *",
      type: "text",
      editable: isAdmin,
      width: 250,
    },
    {
      field: "street",
      headerName: "Straße",
      type: "text",
      editable: isAdmin,
      width: 140,
    },
    {
      field: "regionId",
      headerName: "Ort (Region) *",
      type: "singleSelect",
      editable: isAdmin,
      width: 120,
      getOptionValue: (region) => region?.id,
      getOptionLabel: (region) => region?.regionName,
      valueOptions: regionData,
      valueFormatter: (params) => {
        try {
          const v = params?.value;
          if (v == null || !regionData) return "";
          const region = regionData.find((r) => r.id === v);
          return region?.regionName || "";
        } catch (error) {
          console.error("Region formatting error:", error);
          return "";
        }
      },
      renderCell: (params) => {
        try {
          const v = params?.value;
          if (v == null || !regionData) return "";
          const region = regionData.find((r) => r.id === v);
          return region?.regionName || "";
        } catch (error) {
          console.error("Region rendering error:", error);
          return "";
        }
      },
    },
    {
      field: "zip",
      headerName: "PLZ *",
      type: "number",
      editable: isAdmin,
      width: 100,
      valueFormatter: (params) => {
        const v = params?.value;
        if (v == null || (v !== 0 && !v)) return "";
        return "" + v;
      },
      renderCell: (params) => {
        const v = params?.value;
        if (v == null || (v !== 0 && !v)) return "";
        return v;
      },
    },
    {
      field: "iban",
      headerName: "IBAN *",
      type: "text",
      editable: isAdmin,
      width: 200,
    },
    {
      field: "bic",
      headerName: "BIC *",
      type: "text",
      editable: isAdmin,
      width: 120,
    },
    {
      field: "accountName",
      headerName: "Konto *",
      type: "text",
      editable: isAdmin,
      width: 150,
    },
    {
      field: "taxNumber",
      headerName: "Taxnummer *",
      type: "text",
      editable: isAdmin,
      width: 150,
    },
    {
      field: "tel",
      headerName: "Telephone",
      type: "text",
      editable: isAdmin,
      width: 120,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              onClick={handleSaveClick(id)}
              disabled={!isAdmin}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
              disabled={!isAdmin}
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
            disabled={!isAdmin}
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
            disabled={!isAdmin}
          />,
        ];
      },
    },
  ];

  return columns;
};

export default columnBuilder;
